module.exports = (root, cb) => {
  root.addEventListener(`click`, function(ev) {
    var anchor = null

    for (var n = ev.target; n.parentNode; n = n.parentNode) {
      if (n.nodeName === `A`) {
        anchor = n
        break
      }
    }

    if (!anchor) {
      return true
    }

    if (anchor.protocol === 'triple:') {
      cb(anchor, `${anchor.pathname}${anchor.search || ''}`)
    }

    return true
  })
}
